<script setup lang="ts">
import type { NuxtError } from "#app";

const props = defineProps<{
  error: NuxtError;
}>();

const statusCode = computed(() => props.error?.statusCode || 500);
const isNotFound = computed(() => statusCode.value === 404);

useHead({
  title: computed(() => (isNotFound.value ? "Page not found" : "Unexpected error")),
});

const handleError = () => clearError({ redirect: "/" });
</script>

<template>
  <ion-page class="marketing-layout">
    <ion-content class="marketing-content">
      <section class="bm-section">
        <div class="bm-container" style="padding-block: 4rem">
          <p class="bm-eyebrow">{{ statusCode }}</p>
          <h1 class="bm-display">
            {{ isNotFound ? "Page not found" : "Something went wrong" }}<span class="bm-dot">.</span>
          </h1>
          <p class="bm-lede">
            {{
              isNotFound
                ? "The page you requested does not exist."
                : "An unexpected error occurred while loading this page."
            }}
          </p>
          <button class="bm-btn bm-btn-primary" type="button" @click="handleError">
            Go to homepage <span aria-hidden>→</span>
          </button>
        </div>
      </section>
    </ion-content>
  </ion-page>
</template>
